import {
  InfoOutlined,
  CheckCircleOutlined,
  CancelOutlined,
  ErrorOutline,
} from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import {
  ContainerDialog,
  ContainerIcon,
  DialogTitle,
  DialogContent,
  DialogSubtitle,
  DialogFooter,
} from './styles';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  subtitle: string | string[];
  text?: string;
  btnTextConfirm: string;
  btnTextCancel: string;
  type: 'success' | 'error' | 'info' | 'warning';
  isSubmitting?: boolean;
}

const SX = { width: '80px', height: '80px' };

const iconType = {
  info: <InfoOutlined color="info" sx={SX} />,
  success: <CheckCircleOutlined color="success" sx={SX} />,
  warning: <ErrorOutline color="warning" sx={SX} />,
  error: <CancelOutlined color="error" sx={SX} />,
};

export const ConfirmModal = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  title,
  subtitle,
  text,
  btnTextConfirm,
  btnTextCancel,
  type,
  isSubmitting,
}: ConfirmModalProps) => {
  return (
    <ContainerDialog
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '33.75rem',
            display: 'flex',
            padding: '20px ',
          },
        },
      }}
      open={open}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      className="modal"
    >
      {/* <ContainerIcon>{iconType[type]}</ContainerIcon> */}
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogSubtitle className="alert-subtitle">
          <Typography> {subtitle}</Typography>
          <Typography>{text}</Typography>
        </DialogSubtitle>
      </DialogContent>

      <DialogFooter>
        <Button
          color={type}
          variant="outlined"
          onClick={onCancel}
          sx={{ padding: '16px 22px' }}
          disabled={isSubmitting}
        >
          {btnTextCancel}
        </Button>
        <Button
          color={type}
          variant="contained"
          onClick={onConfirm}
          disabled={isSubmitting}
          endIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          sx={{
            marginLeft: '20px',
            color: '#ffffff',
            padding: '16px 22px',
          }}
        >
          {btnTextConfirm}
        </Button>
      </DialogFooter>
    </ContainerDialog>
  );
};
